import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';

const FullPageLoading: React.FC = () =>
  (<div className="d-flex h-100 flex-column align-items-center justify-content-center">
    <LoadingSpinner />
  </div>);

export default FullPageLoading;
